import actions from '../../actionTypes';

export default action => {
  return {
    type: actions.SET_CURRENT_ACTION,
    action
  };
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/actions/setCurrentAction.js